const Social = () => {
    return (
        
        <div className="social">
            <h2>Socials</h2>

            <a href="https://www.linkedin.com/in/robel-siam-224291222/" target="_blank" rel="noreferrer" className="button">LinkedIn</a>
            <a href="https://github.com/robelsiam" target="_blank" rel="noreferrer" className="button">GitHub</a>
        </div>
        
        
    );
}

export default Social;
